import React from 'react';
import './App.css';
import DocuWizRouter from "./Docuwiz-core/router/DocuWizRouter";

function App() {
  return (
      <DocuWizRouter/>
  );
}

export default App;
